export enum EPromotionType {
  /** Премиум **/
  Premium = 'premium',
  /** Топ **/
  Top = 'top',
  /** Стандарт **/
  Standard = 'standard',
  /** Без продвижения **/
  NoPromotion = 'noPromotion',
}
